import { useMutation } from "@tanstack/react-query";
import { fetchSampleEvaluationPreviewHtml } from "../api/rfx-report-api";
import type { EvaluationPreviewParams, RfxReportPreviewHtmlResponse } from "../types";

export const useSampleEvaluationPreviewHtml = () => {
	return useMutation<RfxReportPreviewHtmlResponse, Error, EvaluationPreviewParams>({
		mutationFn: (params) => fetchSampleEvaluationPreviewHtml(params),
	});
};
